import type { Release } from '../releases.ts';

export default {
  version: '0.24.1',
  date: '2026-10-07',
  title: 'Mobile scrolling and uploads, subtitles on the picture, and consistent numbers',
  summary: [
    'Upload from a phone into a placeholder',
    'Operations shows the same ingest numbers as Monitor',
    'System status groups the graphics renderer and live recording',
    'Fixed: the phone layout scrolls again',
    'Fixed: subtitles sit on the picture and scale with it',
    'Fixed: the Library calls images Images, and Mine is now Collect',
  ],
  features: [
    'On a phone you can upload into a placeholder: its asset page has Upload media (choose a file, take a photo or record video), and the Upload page has a choice between a new asset and Into placeholder…',
    'Monitor → Operations has an Ingests (last 24 h) card that shows the same numbers as Monitor → Ingest; the processing runs it showed before are in their own, clearly named card',
    'System status lists the graphics renderer and live recording in their own groups, and any other service by name',
  ],
  fixes: [
    'The phone layout scrolls again in the Library, on asset pages and on the Upload page',
    'Subtitles are placed on the picture, 7% up from its bottom, and their text size follows the picture, in the player and in the sequence viewer (before, they were placed against the whole viewer, so a 4:3 or portrait picture got them in the black)',
    'The Library’s Media filter calls images Images instead of Audio',
    'The navigation button Mine is now Collect, with the full name Collections in its tooltip',
    'In Monitor, a watch-folder file that was picked up again is counted once, and files that were partly processed count as failed in both Monitor and Operations',
    'Administration lists Storage, Storage agents, Watch folders and Live sources in that order',
  ],
} satisfies Release;
